import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollManager — scroll to top on route change, or to the target section when
 * a hash is present. `scroll-margin-top` on sections keeps the sticky header
 * from covering the anchor (05 §5.3).
 */
const ScrollManager = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return children;
};

export default ScrollManager;
